module.exports = __webpack_public_path__ + "media/src/images/icons/white-close-ee1e6c84b423c102dd64c176b71ce080.svg";